import type { IParagraphEntry } from "~/models/IUserEntry";
import type { ColorPicker } from "~/types/ColorPicker";

type MarkingMode = IParagraphEntry["type"] | "erasing";

export function useMarkingMode() {
  const selectionStore = useSelectionStore();

  const markingMode = ref<MarkingMode>();
  const markerPermanent = ref(false);
  const defaultMarkerColor = ref<ColorPicker>({
    color: "yellow",
    color_type: "lighter",
  });

  const markerColor = ref<ColorPicker>(defaultMarkerColor.value);

  useEventListener("keyup", ({ code }) => {
    if (code === "Escape") {
      markerPermanent.value = false;
    }
  });

  const updateMarkingMode = (mode?: MarkingMode) => {
    markerPermanent.value =
      (mode === "underline" || mode === "mark") && selectionStore.isCollapsed;
    markingMode.value = markingMode.value === mode ? undefined : mode;
  };

  const updateMarkColor = (markerColors: ColorPicker) => {
    if (JSON.stringify(markerColors) === JSON.stringify(markerColor.value)) {
      return (markerColor.value = defaultMarkerColor.value);
    }

    markerColor.value = markerColors;
  };

  return {
    markerColor,
    markerPermanent,
    markingMode,
    updateMarkingMode,
    updateMarkColor,
  };
}
